import React from 'react';
import createReactContext from '../context';
var context = createReactContext(undefined);
var Consumer = context.Consumer; // eslint-disable-next-line

export var Provider = context.Provider;
export var consumer = function consumer(Origin) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(Consumer, null, function (bindChain) {
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            bindChain: bindChain
          }))
        );
      })
    );
  };
};